import styled from 'styled-components';

export const ReplyBody = styled.div`
  font-weight: 400;
  font-size: 12px;
  word-break: break-word;
  line-height: 1.5;
`;
